export const NEWBUILDING_ADFOX_SITE_JK_DESKTOP = 'newbuilding_adfox_site_jk_desktop';
